import React, { useState } from 'react'
import Link from 'next/link'
import { ButtonGroup, Dropdown, Spinner } from 'react-bootstrap'
import classNames from 'classnames'
import useSWR from 'swr'
import { getUserNotifications } from '../../utils/notificationsAPIs'
import NotificationContainer from '../NotificationContainer/NotificationContainer'
import styles from './NotificationDropdown.module.scss'

const NotificationDropdown = ({ adminDashboard = false }) => {
  const { data, error } = useSWR('/api/notifications', () => getUserNotifications())
  const [isOpen, setIsOpen] = useState(false)
  const unreadCount =
    data && data.data ? data.data.filter((i) => !i.isSeen && !i.isMuted).length : 0

  const onDropdownToggle = (toggle) => {
    setIsOpen(toggle)
  }
  return (
    <Dropdown
      as={ButtonGroup}
      className={classNames(styles.notifDropdownWrapper)}
      onToggle={onDropdownToggle}
      show={isOpen}
      alignRight
    >
      <Dropdown.Toggle
        id="dropdown-notification"
        as="a"
        className={classNames(styles.btnNotification, {
          new: unreadCount,
          [styles.admin]: adminDashboard
        })}
      >
        <>
          <svg
            id="notification-bell"
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
          >
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M20.44 11.53c0-3.124-2.01-5.925-5.007-6.977l-.121-.142C15.065 3.357 14.107 2.607 13 2.6c-1.09 0-2.045.74-2.323 1.806l-.13.13C7.553 5.622 5.563 8.41 5.56 11.53l-.004 5.486-.059.131c-.403.413-.784.807-1.105 1.142-.295.31-.527.556-.692.74-.08.087-.158.176-.233.267l -.043.052-.047.064c-.112.163-.127.207-.127.381v.848c0 .457.379.827.847.827l6.27.01.18.14c.378 1.067 1.407 1.783 2.563 1.783 1.158 0 2.186-.72 2.582-1.81l.194-.123h6.017c.468 0 .847-.37.847-.827v-.85c0-.172-.015-.216-.124-.374l-.05-.065-.042-.055a7.62 7.62 0 0 0-.234-.268 40.34 40.34 0 0 0-.692-.74c-.32-.335-.702-.729-1.116-1.158l-.052-.136V11.53zM6.804 17.326V11.53c0-2.773 1.895-5.233 4.607-5.99a.609.609 0 0 0 .45-.584c0-.625.515-1.14 1.139-1.14.633 0 1.137.523 1.137 1.175 0 .273.188.514.458.586 2.702.721 4.601 3.175 4.601 5.953v5.798c0 .156.061.307.173.42.478.488.948.972 1.329 1.37l.115.122.137.143c.158.165.256.267.329.347.073.077.073.077.108.118a.8.8 0 0 1 .04.047c.019.032.019.032.031.06.012.054.012.054.012.094l-.022.07a.16.16 0 0 1-.11.108c-.033.012-.033.012-.092.026h-6.052a.615.615 0 0 0-.622.576c-.045.757-.686 1.348-1.462 1.348-.777 0-1.418-.591-1.463-1.348a.615.615 0 0 0-.621-.576H4.754l-.416-.091.245-.274c.077-.086.53-.572.72-.77.38-.398.85-.882 1.328-1.369a.6.6 0 0 0 .173-.42z"
            ></path>
          </svg>
          <svg
            id="notification-bell-new"
            width="26px"
            height="26px"
            viewBox="0 0 26 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="Icon-/-Notification-/-New"
              stroke="none"
              strokeWidth="1"
              fill="#000"
              fillRule="evenodd"
            >
              <path
                d="M20.4404688,11.5290706 C20.4404688,8.40639405 18.4295313,5.60490706 15.432625,4.55330855 L15.3119688,4.41055762 C15.0645011,3.35688081 14.10748,2.60741485 13,2.6 C11.9092188,2.6 10.9549375,3.33992565 10.6770625,4.40579926 L10.547875,4.53665428 C7.55168466,5.62127438 5.56228626,8.40991578 5.55953125,11.5290706 L5.555875,17.0154647 L5.497375,17.1463197 C5.09396875,17.5591078 4.7125,17.9528625 4.39196875,18.2883271 C4.09703125,18.5976208 3.86546875,18.8438662 3.69971875,19.0282528 C3.62003338,19.1153143 3.54241893,19.2041608 3.4669375,19.2947212 L3.42428125,19.3470632 L3.37675,19.4113011 C3.264625,19.5742751 3.25,19.61829 3.25,19.7919703 L3.25,20.6401487 C3.25,21.0969517 3.62903125,21.4669145 4.09703125,21.4669145 L10.3675,21.4776208 L10.547875,21.616803 C10.9247766,22.6836725 11.9535093,23.3997409 13.1096875,23.4 C14.2675,23.4 15.296125,22.6802974 15.6922188,21.5894424 L15.886,21.4669145 L21.9029687,21.4669145 C22.3707712,21.4669145 22.75,21.0967588 22.75,20.6401487 L22.75,19.7907807 C22.75,19.61829 22.735375,19.5742751 22.6256875,19.4160595 L22.5769375,19.350632 L22.5342812,19.2959108 C22.4584169,19.2049334 22.3803959,19.11569 22.3002813,19.0282528 C22.072708,18.7787972 21.8419398,18.5321359 21.6080313,18.2883271 C21.2875,17.9528625 20.9060313,17.5591078 20.4916563,17.1296654 L20.4404688,16.994052 L20.4404688,11.5290706 L20.4404688,11.5290706 Z M6.803875,17.3271375 L6.803875,11.5290706 C6.803875,8.75613383 8.69903125,6.29605948 11.41075,5.53828996 C11.677476,5.46396779 11.8614656,5.22613563 11.8616875,4.95539033 C11.8616875,4.32966543 12.376,3.81457249 13,3.81457249 C13.6325313,3.81457249 14.1370938,4.33799257 14.1370938,4.98988848 C14.1370938,5.26349442 14.3247813,5.50379182 14.5953438,5.57635688 C17.2973125,6.29724907 19.196125,8.75137546 19.196125,11.5290706 L19.196125,17.3271375 C19.196125,17.482974 19.2570625,17.634052 19.3691875,17.7470632 C19.8469375,18.2347955 20.317375,18.7189591 20.697625,19.1162825 L20.8134062,19.2388104 L20.9499063,19.3815613 C21.1083438,19.5469145 21.2058438,19.6492193 21.2789688,19.7289219 C21.3520938,19.8062454 21.3520938,19.8062454 21.3874375,19.8466914 C21.4010542,19.8620616 21.4140637,19.8779344 21.4264375,19.8942751 C21.4459375,19.9263941 21.4459375,19.9263941 21.458125,19.9537546 C21.4703125,20.0084758 21.4703125,20.0084758 21.4703125,20.0477323 L21.448375,20.1179182 C21.4331732,20.1699307 21.3918036,20.2107592 21.3386875,20.226171 C21.3045625,20.2380669 21.3045625,20.2380669 21.2460625,20.252342 L15.19375,20.252342 C14.8624739,20.2519216 14.5890758,20.505174 14.5721875,20.8281041 C14.5274266,21.5845209 13.885937,22.1755409 13.1096875,22.1755409 C12.333438,22.1755409 11.6919484,21.5845209 11.6471875,20.8281041 C11.6302992,20.505174 11.3569011,20.2519216 11.025625,20.252342 L4.7539375,20.252342 L4.33834375,20.1607435 L4.5833125,19.8871375 C4.66009375,19.801487 5.11346875,19.3149442 5.302375,19.1162825 C5.682625,18.7189591 6.1530625,18.2347955 6.6308125,17.7482528 C6.74213001,17.6350125 6.80416008,17.4840739 6.803875,17.3271375 L6.803875,17.3271375 Z"
                id="Shape"
                fill="#fff"
              ></path>
              <circle
                id="Oval"
                stroke="#FFFFFF"
                strokeWidth="1.3"
                fill="#F33637"
                cx="19.75"
                cy="6.75"
                r="4.4"
              ></circle>
            </g>
          </svg>
        </>
      </Dropdown.Toggle>
      <Dropdown.Menu className={classNames(styles.dropdownMenu)}>
        <div className={styles.titleContainer}>
          <p className="mb-0">
            NOTIFICATIONS
            {unreadCount > 0 && <span className="badge badge-pill mx-2 px-2">{unreadCount}</span>}
          </p>
        </div>
        {error && <p className="lead text-center">Something went wrong.</p>}
        {!data && !error ? (
          <div className="text-center p-3">
            <Spinner animation="border" />
          </div>
        ) : null}
        {data && (
          <NotificationContainer
            id="notification-dropdown"
            notificationData={data.data}
            from="dropdown"
            fromDropdown
            isDropdownOpen={isOpen}
          />
        )}
        <div className={styles.viewAllContainer}>
          <Link href={adminDashboard ? '/en/notifications' : '/en/dashboard/notifications'}>
            <a>VIEW ALL</a>
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default NotificationDropdown
